export default __webpack_public_path__ + "static/media/icon-clothes.835f9813.png";